export enum HistoryActionEnum
{
    none = "none",
    push = "push",
    replace = "replace",
}